export default "__VITE_ASSET__e17903f8__"